import type { Palette } from "@designboticteam/core";
import type { LayerStyleStates, PmTilesSourceDefinition } from "@designboticteam/map";
import { PARCELS_PMTILES_SOURCE_ID } from "../constants";

/** How a parcel looks when no visualization mode is active, and what the colour modes fall back to. */
function createParcelsBaseStyle(palette: Palette): LayerStyleStates {
	const color = palette.main.tertiary;

	return {
		idle: {
			outline: { color, opacity: 0.2, width: 1 },
			fill: { color, opacity: 0 },
		},
		matched: {
			fill: { color, opacity: 0.5 },
		},
		hover: {
			outline: { color: palette.neutral.black, opacity: 0.5 },
			fill: { color, opacity: 0.75 },
		},
	};
}

/** The pmtiles registration for parcels, whose base style is what makes the fill and outline layers exist. */
function createParcelsSourceDefinition({ palette, url }: { palette: Palette; url: string }): PmTilesSourceDefinition {
	return {
		id: PARCELS_PMTILES_SOURCE_ID,
		url,
		label: "Parcels",
		promoteId: "parcel__id_dzialki",
		minzoom: 13,
		displaySettings: {
			isVisible: false,
			isHoverable: true,
			opacity: 1,
		},
		type: "vector",
		style: createParcelsBaseStyle(palette),
	};
}

export { createParcelsBaseStyle, createParcelsSourceDefinition };
